import i18n from '@/Config/app/i18n';
import { BoolIcon } from '@/Domain/components/icons/Bool.icon';
import { FloatIcon } from '@/Domain/components/icons/Float.icon';
import { IntIcon } from '@/Domain/components/icons/Int.icon';
import { StringIcon } from '@/Domain/components/icons/String.icon';
import { ParameterTypeEnum } from '@/Domain/enum/ParameterType.enum';
import { getApiKey, getCurrentScenarioId } from '@/context';

const MCP_INTEGRATION = (name: string, withApiKey: boolean) => ({
  [name]: {
    command: 'uvx',
    args: ['quickchat-ai-mcp'],
    env: {
      SCENARIO_ID: getCurrentScenarioId(),
      ...(withApiKey ? { API_KEY: getApiKey() } : {}),
    },
  },
});

export const ActionHelper = {
  generateMcpIntegrationConfig: (type: 'claude' | 'other', name: string, withApiKey: boolean) => {
    // Both `claude` and the generic "other" target currently share the same
    // command shape — the distinction is kept in the API surface for future use.
    void type;
    return MCP_INTEGRATION(name, withApiKey);
  },

  mapParameterTypeToValueType: (
    value: string | number | boolean,
    type = ParameterTypeEnum.String,
  ) => {
    switch (type) {
      case ParameterTypeEnum.Int:
        return Number(value);
      case ParameterTypeEnum.Float:
        return Number(value.toString().replace(',', '.'));
      case ParameterTypeEnum.Boolean:
        return Boolean(Number(value));
      default:
        return value;
    }
  },

  convertToObject: (item: Record<string, any>[]): Record<string, any> =>
    item.reduce<Record<string, any>>((acc, { name, value, type = ParameterTypeEnum.String }) => {
      const normalizedName = String(name ?? '')
        .replace(/\{\{\s*|\s*\}\}/g, '')
        .trim();

      return {
        [normalizedName]: ActionHelper.mapParameterTypeToValueType(value, type),
        ...acc,
      };
    }, {}),

  parameterTypeToLabel: (key: ParameterTypeEnum) => {
    const config = {
      [ParameterTypeEnum.String]: {
        label: i18n.t('actions_page:sheet.form.data_to_collect.data_type.string'),
        TypeIcon: StringIcon,
      },
      [ParameterTypeEnum.Int]: {
        label: i18n.t('actions_page:sheet.form.data_to_collect.data_type.int'),
        TypeIcon: IntIcon,
      },
      [ParameterTypeEnum.Float]: {
        label: i18n.t('actions_page:sheet.form.data_to_collect.data_type.float'),
        TypeIcon: FloatIcon,
      },
      [ParameterTypeEnum.Boolean]: {
        label: i18n.t('actions_page:sheet.form.data_to_collect.data_type.boolean'),
        TypeIcon: BoolIcon,
      },
    };

    return config[key];
  },
};
